import {HomePage} from "../containers/Home/Home";

export default HomePage;
